import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function PantoneOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_190)'>
        <path
          d='M20 13.18H15.94L18.24 10.71C18.4263 10.5226 18.5308 10.2692 18.5308 10.005C18.5308 9.74081 18.4263 9.48736 18.24 9.3L14.05 5.44C13.9565 5.34936 13.8449 5.27938 13.7226 5.23459C13.6003 5.1898 13.47 5.1712 13.34 5.18C13.2087 5.18316 13.0793 5.21217 12.9592 5.26536C12.8391 5.31855 12.7306 5.39488 12.64 5.49L10.82 7.49V4C10.82 3.73478 10.7146 3.48043 10.5271 3.29289C10.3396 3.10536 10.0852 3 9.82 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V17.09C3 18.127 3.41195 19.1215 4.14521 19.8548C4.87848 20.5881 5.873 21 6.91 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V14.18C21 13.9148 20.8946 13.6604 20.7071 13.4729C20.5196 13.2854 20.2652 13.18 20 13.18ZM13.42 7.59L16.09 10.08L10.82 15.74V10.38L13.42 7.59ZM8.82 10V13H5V10H8.82ZM8.82 5V8H5V5H8.82ZM5 17.09V15H8.82V17.09C8.82 17.5966 8.61877 18.0824 8.26057 18.4406C7.90238 18.7988 7.41656 19 6.91 19C6.40344 19 5.91762 18.7988 5.55943 18.4406C5.20123 18.0824 5 17.5966 5 17.09ZM19 19H10.51L14.07 15.18H19V19Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_190'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
